"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adornmentIcons = exports.EMAIL_INPUT = void 0;
var _icons = require("@ori-ui/icons");
var _jsxRuntime = require("react/jsx-runtime");
const EMAIL_INPUT = exports.EMAIL_INPUT = 'email-input';
const adornmentIcons = exports.adornmentIcons = {
  error: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ErrorCircle, {
    color: "error"
  }),
  success: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.CheckCircle, {
    color: "inherit"
  })
};